
import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';


@Component({
    selector: 'app-nba-details',
    templateUrl: './nba-details.component.html',
    styleUrls: ['./nba-details.component.scss']
  })
  export class NbaDetailsComponent {
    @Input() name: string;
    @Input() address: string;
    @Input() postalCode: string;
    @Input() city: string;
    @Input() phoneNumber: string;
    @Input() mobileNumber: string;
    @Input() email: string;
  }

